<div class="card cardsmall">
    <div class="grid grid-nogutter flex-wrap gap-3 p-fluid">
        <div class="col-12 pl-2">
                <p-tabView>
                    
                    <p-tabPanel header="{{tabsFields[0].title}}">
                        <form [formGroup]="form">
                            <div class="formgrid">       
                                <formly-form [model]="model" 
                                [fields]="tabsFields[0].fields" 
                                [options]="options" 
                                [form]="form"></formly-form>                     
                            </div>
                        </form>
                    </p-tabPanel>
                    
                    
                </p-tabView>

        </div>
    </div>
</div>
<div class="grid">
    <div class="col-12">
        <div class="flex-1 w-full lg:w-3 xl:w-4 flex flex-column row-gap-3">
            <div class="flex flex-column sm:flex-row gap-3 py-2">
                <button
                pButton pRipple class="p-button-danger flex-1 p-button-outlined" 
                (click)="annulla()"
                label="{{lang.el('Annulla')}}"></button>
                <button  *ngIf="action!='delete'"
                pButton pRipple class="p-button-primary flex-1 border-round" 
                (click)="save()"
                [disabled]="!form.valid"
                label="{{lang.el('Salva')}}" icon="pi pi-fw pi-check"></button>
                <button  *ngIf="action=='delete'"
                pButton pRipple class="p-button-primary flex-1 border-round" 
                (click)="delete()"
                label="{{lang.el('Cancella')}}" icon="pi pi-fw pi-trash"></button>
            </div>
        </div>
    </div>
</div>
<p-toast></p-toast>
